// src/theme.js
import { createTheme } from '@mui/material/styles';

const colors = {
  black: '#000000',
  darkRed: '#451a15',
  red: '#970000',
  yellow: '#fdb200',
  offWhite: '#f6ede7',
};

const theme = createTheme({
  palette: {
    primary: { main: colors.darkRed },
    secondary: { main: colors.yellow },
    background: { default: colors.offWhite },
    text: { primary: colors.black },
  },
  typography: {
    fontFamily: 'Exo, sans-serif',
    h1: {
      fontFamily: 'Exo, sans-serif',
      fontWeight: 'bold',
    },
    h2: {
      fontFamily: 'Exo, sans-serif',
      fontWeight: 'bold',
    },
    // h3, h4, etc. as needed...
  },
});

export default theme;
